<sh-vertical-nav
    collapser="bottom"
    background="surface"
    [attr.collapsed]="collapsed() ? true : null"
    (collapsed-changed)="onCollapsedChanged($event)"
    class="w-[300px]"
>
    <sh-vertical-nav-item
        icon="home"
        routerLink="/"
        routerLinkActive
        #homeLink="routerLinkActive"
        [routerLinkActiveOptions]="{ exact: true }"
        [attr.active]="homeLink.isActive ? true : null"
        label="Home"
    ></sh-vertical-nav-item>
    <sh-vertical-nav-item
        icon="message-history"
        routerLink="/requests"
        routerLinkActive
        #requestsLink="routerLinkActive"
        [attr.active]="requestsLink.isActive ? true : null"
        label="Requests"
    ></sh-vertical-nav-item>
    @if (!collapsed()) {
        @for (tab of tabs(); track tab.id) {
            <sh-vertical-nav-item
                icon="table-out"
                class="pl-4"
                [label]="'MDLA-' + tab.displayId"
                [attr.active]="activeTabId() === tab.id ? true : null"
                (click)="openTab(tab.id)"
            >
                <sh-icon slot="functions" icon="cancel" size="s" button (click)="closeTab(tab.id, $event)"></sh-icon>
            </sh-vertical-nav-item>
        }
    }
    <sh-vertical-nav-item
        icon="plus"
        routerLink="/request"
        routerLinkActive
        #createRequestLink="routerLinkActive"
        [routerLinkActiveOptions]="{ exact: true }"
        [attr.active]="createRequestLink.isActive ? true : null"
        label="Create Request"
    ></sh-vertical-nav-item>
    <sh-vertical-nav-item
        icon="open-tasks-add"
        routerLink="/request"
        [queryParams]="{ type: 'PURCHASE_ORDER' }"
        routerLinkActive
        #purchaseOrderLink="routerLinkActive"
        [routerLinkActiveOptions]="{ exact: true }"
        [attr.active]="purchaseOrderLink.isActive ? true : null"
        label="Submit a Purchase Order"
    ></sh-vertical-nav-item>
    @if (isAdmin()) {
        <sh-vertical-nav-item
            icon="access-control"
            routerLink="/admin"
            routerLinkActive
            #adminLink="routerLinkActive"
            [attr.active]="adminLink.isActive ? true : null"
            label="Admin Area"
        ></sh-vertical-nav-item>
    }
</sh-vertical-nav>
